import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import parse from "html-react-parser";
import { fetchAppInfo } from "../../network/service";
import { useEffect } from "react";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../../Components/Loading/Loading";


const PrivacyPolicy = () => {
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState("");
  const wrapperRef = useRef(null);
  const location = useLocation();
  useEffect(() => {
    window.scroll(0,0)
    fetchPrivacyPolicyData();
  }, []);
  const fetchPrivacyPolicyData = async () => {
    setLoading(true)
    try{
      const params = {
        type: "PRIVACY_POLICY",
      };
      const response = await fetchAppInfo(params);
      if (response?.status === 200) {
        setData(response?.data?.data?.value);
        setLoading(false)

      }
    }catch(err){
      setLoading(false)
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
   
  };

  useEffect(() => {
    const hash = decodeURIComponent(location.hash.replace("#", ""));
    if (loading || !hash || !wrapperRef.current) return;

    const target = wrapperRef.current.querySelector(`[id="${CSS.escape(hash)}"]`);
    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [loading, data, location.hash]);

  if(loading){
    return(
      <Loading/>
    )
  }

  return (
    <div className="privacyPolicy">
      <ToastContainer/>

      <div className="wrapper" ref={wrapperRef}>{parse(data)}</div>
      {/* <div dangerouslySetInnerHTML={{__html: '<strong>strong text</strong>'}} /> */}
    </div>
  );
};

export default PrivacyPolicy;
